const AUD_FORMAT: Intl.NumberFormatOptions = { style: 'currency', currency: 'AUD' };

export function formatAud(scale6: string): string {
  return Number(scale6).toLocaleString('en-AU', AUD_FORMAT);
}

/** Sub-cent aware: chat-scale amounts round to $0.00 under the plain 2dp formatter. */
export function formatAudPrecise(scale6: string): string {
  const value = Number(scale6);
  if (!Number.isFinite(value) || value === 0) {
    return formatAud('0');
  }
  const magnitude = Math.abs(value);
  if (magnitude >= 0.01) {
    return formatAud(scale6);
  }
  if (magnitude < 0.0001) {
    return `<${formatAudFraction(value < 0 ? -0.0001 : 0.0001)}`;
  }
  return formatAudFraction(value);
}

function formatAudFraction(value: number): string {
  return value.toLocaleString('en-AU', {
    ...AUD_FORMAT,
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  });
}
